// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#tabs_messages .v-tabs-items{background-color:transparent!important}.timeline_message .v-timeline-item__divider{padding-top:25px!important}", ""]);
// Exports
module.exports = exports;
